import * as api from "../../helpers/api_helper";
import qs from "qs";
import { GET, GET_ALL, GET_ALL_XML, GET_TYPES, POST, PUT, PUT_ASSOCIATE, PUT_DISSASOCIATE, PUT_TOGGLE, PUT_OPEN, PUT_REJECT, DOWNLOAD, SAVE_PREVALORIZATION_URL, GET_ALL_STATES, GET_ALL_ASSIGNED, GET_ALL_NOTASSIGNED, POST_SAVEASSIGNED, GET_ALL_PAGETYPE, GET_ALL_PROCCESS, POST_SAVEAATTACHS, GET_ALL_ASSIGNED_FOR_DOCUMENTID, POST_SAVEAPPROVAL, POST_SAVEREACTIVE, ALLEXPORT, POST_DISSASOCIATE, GET_ALL_REJECTION_REASON } from "./url";

export const getAll = (filter) => api.get(GET_ALL, {
  params: { ...filter },
  paramsSerializer: params => {
    return qs.stringify(params)
  }
});

export const getAllAssigned = (filter) => api.get(GET_ALL_ASSIGNED, {
  params: { ...filter },
  paramsSerializer: params => {
    return qs.stringify(params)
  }
});

export const getAllNotAssigned = () => api.get(GET_ALL_NOTASSIGNED, {});


export const getAllPageType = () => api.get(GET_ALL_PAGETYPE, {});


export const getAllStatus = (filter) => {

  return api.get( GET_ALL_STATES, {
  });
};
export const getAllTransmissions = (filter) => api.get(GET_ALL_XML, {
  params: { ...filter },
  paramsSerializer: params => {
    return qs.stringify(params)
  }
});

export const getByDocumentNumber = (filter) => api.get(GET_ALL, {
  params: { ...filter },
  paramsSerializer: params => {
    return qs.stringify(params)
  }
});
export const getTypes = (filter) => api.get(GET_TYPES, {
  params: { ...filter },
  paramsSerializer: params => {
    return qs.stringify(params)
  }
});

export const getAllAssignedForDocumentId = (filter) =>
{

  
  return api.get(GET_ALL_ASSIGNED_FOR_DOCUMENTID, {
    params: { ...filter },
    paramsSerializer: params => {
      return qs.stringify(params)
    }
  });
};

export const getRejectionReasonAll = () =>
{

  return api.get(GET_ALL_REJECTION_REASON, {
    paramsSerializer: params => {
      return qs.stringify(params)
    }
  });
};


export const exportDocument = (filter) => api.download(DOWNLOAD, {
  params: { ...filter },
  paramsSerializer: params => {
    return qs.stringify(params)
  }
});


export const exportAllDocument = (filter) => api.download(ALLEXPORT, {
  params: { ...filter },
  paramsSerializer: params => {
    return qs.stringify(params)
  }
});

// export const disassociateService = (id) => api.put(PUT_DISSASOCIATE, { id: id });
export const disassociateService = (id) => api.postAdapter(POST_DISSASOCIATE, null, id);

export const associateService = (documentNumber) => api.put(PUT_ASSOCIATE, { ...documentNumber });
export const openService = (id) => api.put(PUT_OPEN, { id: id });
export const rejectService = (data) => api.put(PUT_REJECT, data );
export const get = (id) => api.get(`${GET}${id}`);
export const post = (user) => api.post(POST, user);
export const postSaveAssigned =  (obj) => api.postAdapter(POST_SAVEASSIGNED, obj);

export const postSaveAttachs =  (obj) => api.postAdapter(POST_SAVEAATTACHS, obj);

export const postSaveApproval =  (obj) => api.postAdapter(POST_SAVEAPPROVAL, obj);

export const postSaveReactive =  (obj) => api.postAdapter(POST_SAVEREACTIVE,null, obj);

export const postProccessService = (data) =>  {

 const formData = new FormData();
  // Agrega el archivo al formData
  formData.append('file', data);
  return api.postFormData(GET_ALL_PROCCESS, formData,{
    headers: { "Content-Type": "multipart/form-data" }
  })
};

export const update = (user) => api.put(PUT, user);
export const putTypes = (entity) => api.put(PUT_TOGGLE, entity);